import { render, staticRenderFns } from "./distwithdrawtype.vue?vue&type=template&id=f8e4124a&"
import script from "./distwithdrawtype.vue?vue&type=script&lang=js&"
export * from "./distwithdrawtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports